export default __webpack_public_path__ + "static/media/main_title_cv.5d112df9.svg";